export default __webpack_public_path__ + "static/media/nubes.ef351f1b.png";